import {useQuery} from "react-query";
import axios from "services/axios";

export const QUERY_CUSTOM_PAYMENT_METHOD = "custom-payment-method";

export function getCustomPaymentMethods() {
	return axios.get("/v2/payment-methods?provider=custom&active=true,false").then(res => res.data);
}

export function useCustomPaymentMethods() {
	return useQuery([QUERY_CUSTOM_PAYMENT_METHOD], () => getCustomPaymentMethods(), {
		refetchOnWindowFocus: false,
	});
}

export function getCustomPaymentMethodById(id) {
	return axios.get(`/v2/payment-methods/${id}`).then(res => res.data);
}

export function useCustomPaymentMethodDetail(id) {
	return useQuery([QUERY_CUSTOM_PAYMENT_METHOD, id], () => getCustomPaymentMethodById(id), {
		enabled: !!id,
		refetchOnWindowFocus: false,
	});
}
